/*
 * @Author: zhang lin
 * @Date: 2022-04-07 11:03:35
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2023-05-06 10:47:26
 * @Description: file content
 */
// common
// 服务器状态
export const SERVER_STATUS = 'server_status';
// 平台状态
export const SYS_STATUS = 'sys_status';
export const UPDATE_ENV = 'update_env';
export const UPDATES_DIR = 'update_dir';

// install
export const GET_CURRENT = 'get_current';
export const SET_CURRENT = 'set_current';
export const GET_CHECKFN = 'get_checkFn';
export const SET_OPERATE = 'set_operate';

// 获取磁盘数据
export const GET_DISKDATA = 'get_diskData';

// 修改磁盘容量
export const UPDATE_DISKDATA = 'update_diskData';

// fileConfig
export const CHANGE_TAB = 'change_tab';
export const UPDATE_QUEUE = 'UPDATE_QUEUE';
export const ADD_QUEUE = 'addQueue';
export const ADD_PACK = 'addPack';
export const DELETE_QUEUE = 'deleteQueue';
export const SELECT_VERSION = 'select_version';
export const CLEAR_FILE_CONFIG = 'clear_file_config';
export const CHAGNE_FORM = 'change_form';
export const CHANGE_SYSTEM = 'change_system';
export const SET_SOURCE_DATA = 'set_source_data';
export const SET_OPERATION = 'set_oparation';
export const DIFF_QUEUE = 'diff_queue';
export const SET_UPDATE_METHOD = 'set_update_method';

// nodeConfig
export const CHAGNE_NODE_FORM = 'change_node_form';
export const SELECT_NODE_VERSION = 'select_node_version';
export const SET_HOSTS = 'set_hosts';
export const SET_INSTALLA_TYPE = 'set_install_type';
export const SET_NODE_DATA = 'set_node_data';

// 扩展分区与调整磁盘
export const GET_DISKID = 'get_diskID';
export const FILTER_RECORD = 'filter_record';
export const UPDATE_RECORD = 'update_record';
export const GET_RECORD = 'get_record';
export const GET_VISIBLE = 'get_visible';

// 备份还原
export const GET_LOG_RECORD = 'get_log_record';
export const SET_LODING = 'set_loding';

// 运行环境管理
export const CHANGEENVSTATUS = 'changeEnvStatus';

// 纳管页面
export const CHANGE_STATUS = 'change_status';
export const CHANGE_PAGE = 'chage_page';

// 多租户
export const SET_IS_MULTI_TENANT = 'setIsMultiTenant';
export const SET_DOMAIN = 'setDomain';
